import * as React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {Button, Form, Grid, Input, Space, Typography} from 'antd';
import {AuthFormContainer} from 'components/AuthFormContainer';
import {getIsMobile} from 'helpers/utils';
import {observer} from 'mobx-react-lite';
import {AuthRoutePaths} from 'routing/Routes';
import {appState} from 'store/AppStore';

export const ForgotPasswordView: React.FC = observer((): JSX.Element => {
  const {t} = useTranslation();

  const screen = Grid.useBreakpoint();

  const isMobile = React.useMemo(() => getIsMobile(screen), [screen]);
  return (
    <AuthFormContainer>
      <Space direction="vertical">
        <Typography.Title level={isMobile ? 2 : 1}>{t('Send Reset Link')}</Typography.Title>
        <Form onFinish={(values) => appState.sendResetLink(values)} layout="vertical">
          <Form.Item
            required
            label={t('Email')}
            name="email"
            rules={[{required: true, message: String(t('Email is required.'))}, {type: 'email'}]}
          >
            <Input placeholder={t('Email')} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {String(t('Send Reset Link'))}
            </Button>
            <Link to={AuthRoutePaths.signIn.url}>
              <Button type="link" className="p-0">
                {String(t('Back to login page'))}
              </Button>
            </Link>
          </Form.Item>
        </Form>
      </Space>
    </AuthFormContainer>
  );
});
